import type {Item} from '@PosterWhiteboard/items/item/item.class';
import type {ItemLoadingOverlay} from '@PosterWhiteboard/items/item/item.types';
import {ItemLoadingOverlayType, ItemRenderDecorationType} from '@PosterWhiteboard/items/item/item.types';
import {deregisterLoadingItem, getLoadingPhase, registerLoadingItem} from '@PosterWhiteboard/items/item/item-loading-ticker';
import {paintItemLoadingOverlay} from '@PosterWhiteboard/items/item/item-loading-overlay.util';

export class ItemLoadingAnimation {
  private readonly item: Item;
  private active = false;
  private overlay: ItemLoadingOverlay | null = null;

  public constructor(item: Item) {
    this.item = item;
  }

  public get isActive(): boolean {
    return this.active;
  }

  public start(overlay: ItemLoadingOverlay): void {
    this.overlay = overlay;
    if (this.active) {
      return;
    }

    this.active = true;
    this.item.renderDecorations.add(ItemRenderDecorationType.LOADING, (ctx, renderBase) => {
      this.paint(ctx, renderBase);
    });

    if (overlay.type === ItemLoadingOverlayType.ANIMATED) {
      registerLoadingItem(this.item);
    }
  }

  public stop(): void {
    if (!this.active) {
      return;
    }

    this.active = false;
    this.overlay = null;
    deregisterLoadingItem(this.item);
    this.item.renderDecorations.remove(ItemRenderDecorationType.LOADING);
  }

  private paint(ctx: CanvasRenderingContext2D, renderBase: (ctx: CanvasRenderingContext2D) => void): void {
    if (!this.overlay) {
      return;
    }

    const {width, height} = this.item.fabricObject;
    paintItemLoadingOverlay(ctx, renderBase, width, height, this.overlay, getLoadingPhase());
  }
}
